(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('#GowinContactForm');
    const topics = [...root.querySelectorAll('.topic')];
    const topicInput = form.querySelector('input[name="contact[Enquiry type]"]');
    const message = root.querySelector('#gw-contact-message');
    const fields = ['name', 'email', 'message'].map(key => root.querySelector('#gw-contact-' + key));
    const text = key => root.dataset[key];
    const prompts = [text('furniturePrompt'), text('projectPrompt'), text('visitPrompt')];
    const list = root.querySelector('.topic-options');
    function moveUnderline() {
      const selected = root.querySelector('.topic.active');
      list.style.setProperty('--topic-x', selected.offsetLeft + 'px');
      list.style.setProperty('--topic-scale', String(selected.offsetWidth));
      list.style.setProperty('--topic-y', selected.offsetTop + selected.offsetHeight + 'px');
    }
    topics.forEach((button, index) => button.addEventListener('click', () => {
      topics.forEach(topic => {
        const active = topic === button;
        topic.classList.toggle('active', active);
        topic.setAttribute('aria-pressed', String(active));
      });
      topicInput.value = button.dataset.topic;
      message.placeholder = prompts[index];
      moveUnderline();
    }));
    if (document.fonts) document.fonts.ready.then(moveUnderline);
    else moveUnderline();
    if ('ResizeObserver' in window) new ResizeObserver(moveUnderline).observe(list);
    else window.addEventListener('resize', moveUnderline);
    root.querySelector('.copy-address').addEventListener('click', async function () {
      const address = root.querySelector('address').textContent.replace(/\s+/g, ' ').trim();
      const status = root.querySelector('.copy-status');
      try {
        await navigator.clipboard.writeText(address);
        this.querySelector('span').textContent = text('copied');
        status.textContent = text('copyStatus');
      } catch {
        status.classList.remove('sr-only');
        status.textContent = text('copyFallback') + ' ' + address;
      }
    });
    const status = root.querySelector('.form-status.client-status');
    function validate(field) {
      let error = '';
      if (!field.value.trim()) error = field.id.endsWith('-name') ? text('errorName') : field === message ? text('errorMessage') : text('errorEmail');
      else if (field.type === 'email' && !field.validity.valid) error = text('errorEmailFormat');
      field.setAttribute('aria-invalid', String(Boolean(error)));
      root.querySelector('#' + field.id + '-error').textContent = error;
      return !error;
    }
    fields.forEach(field => field.addEventListener('input', () => {
      if (field.getAttribute('aria-invalid') === 'true') validate(field);
      status.textContent = '';
    }));
    form.addEventListener('submit', event => {
      const invalid = fields.filter(field => !validate(field));
      if (invalid.length) {
        event.preventDefault();
        status.textContent = text('errorSummary');
        invalid[0].focus();
      }
    });
  }
  init(document.querySelector('#GowinContact'));
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('#GowinContact')));
})();
